import Grid from '@mui/material/Grid';
import TextFieldComp from '../../../components/TextField/textFieldComp';
import Box from '@mui/material/Box';
import ButtonComp from '../../../components/Button/buttonComp';
import PropTypes from 'prop-types';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useEffect, useState } from 'react';
import DropdownTextComp from '../../../components/Dropdown/dropDownTextComp';
import Strings from '../../../constants/stringConstant';
import makeApiCall from '../../../api/makeApiCall';
import { fetchEstampStates } from '../../../api/request/masterFetchApi/masterFetchApi';

function AddEditEStampMaster({
    closeModal = () => { },
    type = 'add',
    selectedRowObject = {},
    addUpdateEStampMasterApi,
}) {
    const [states, setStates] = useState([]);
    useEffect(() => {
        fetchStateData();
    }, []);
    const validationSchema = Yup.object().shape({
        stateName: Yup.string()
            .matches(/^[A-Za-z\s]{1,50}$/, 'Invalid State name')
            .required('State name is required'),
        stampSeriesNumber: Yup.string()
            .matches(/^\d{1,10}$/, 'Invalid Stamp Series Number')
            .required('Stamp Series Number is required'),
    });

    const formik = useFormik({
        initialValues:
            type === 'add'
                ? {
                    id: '',
                    stateName: '',
                    stampSeriesNumber: '',
                }
                : selectedRowObject,
        enableReinitialize: true,
        validationSchema,
        onSubmit: async values => {
            try {
                await addUpdateEStampMasterApi(values, states);
                closeModal();
            } catch (error) {
                console.error('API Error:', error);
            }
        },
    });
    const fetchStateData = async () => {
        try {
            const response = await makeApiCall(fetchEstampStates());
            if (response?.data?.status === Strings.success) {
                const stateData = response?.data?.data;
                setStates(stateData || []);
            }
        } catch (error) {
            console.error('API Error:', error);
        }
    };

    return (
        <form onSubmit={formik.handleSubmit} noValidate>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: '48px' }}>
                <Grid container spacing={'16px'}>
                    <Grid item xs={12} md={6}>
                        <DropdownTextComp
                            label={'State Name'}
                            name={'stateName'}
                            required
                            selectedValue={formik.values['stateName'] ?? ''}
                            handleChange={formik.handleChange}
                            options={states?.map(data => data?.stateName)}
                            error={
                                formik.touched['stateName'] &&
                                Boolean(formik.errors['stateName'])
                            }
                            errorMessage={
                                formik.touched['stateName'] && formik.errors['stateName']
                            }
                            onBlur={formik.handleBlur}
                        />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <TextFieldComp
                            label={'Stamp Series Number'}
                            name={'stampSeriesNumber'}
                            required
                            value={formik.values['stampSeriesNumber'] ?? ''}
                            onChange={formik.handleChange}
                            error={
                                formik.touched['stampSeriesNumber'] &&
                                Boolean(formik.errors['stampSeriesNumber'])
                            }
                            errorMessage={
                                formik.touched['stampSeriesNumber'] && formik.errors['stampSeriesNumber']
                            }
                            onBlur={formik.handleBlur}
                            maxLength={10}
                        />
                    </Grid>
                </Grid>

                <Grid container spacing={'16px'}>
                    <Grid item xs={12} md={6}>
                        <ButtonComp
                            variant="outlined"
                            className="text-bold-16px"
                            value="Cancel"
                            height="48px"
                            width="100%"
                            padding="14px 24px"
                            textcolor="#F37021"
                            borderRadius="8px"
                            border="1px solid #F37021"
                            onClick={closeModal}
                        />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <ButtonComp
                            type="submit"
                            className="text-bold-16px"
                            value={type === 'add' ? 'Add' : 'Save'}
                            disabled={!formik.dirty || !formik.isValid}
                            gradient="linear-gradient(168deg, #F37021 -13.5%, #FDBA12 119.9%)"
                            height="48px"
                            width="100%"
                            padding="14px 24px"
                            textcolor="#fff"
                            borderRadius="8px"
                        />
                    </Grid>
                </Grid>
            </Box>
        </form>
    );
}

AddEditEStampMaster.propTypes = {
    closeModal: PropTypes.func,
    type: PropTypes.string,
    selectedRowObject: PropTypes.object,
    addUpdateEStampMasterApi: PropTypes.func.isRequired,
};

export default AddEditEStampMaster;
